let FileOperations = {
  downloadFile: function(url, onSuccess, onError) {
    onError && onError()
  },

  progress: function(identifier, callback) {
    // Not that hard to implement, but not worthwhile right now
  },

  cancel: function(identifier, callback) {
    callback && callback()
  },

  uploadFile: function(options, cb) {
    cb("error - unavailable on this platform", null)
  },
}

window.FileOperations = FileOperations

export default FileOperations
